{
  "enter": "Enter your {label}",
  "update": "Update your {label}",
  "masked_placeholder": "***********"
}
